export const FETCH_APPLICATIONS_START = 'FETCH_APPLICATIONS_START';
export const FETCH_APPLICATIONS_SUCCESS = 'FETCH_APPLICATIONS_SUCCESS';
export const FETCH_APPLICATIONS_FAIL = 'FETCH_APPLICATIONS_FAIL';